export { default } from './CopyOnClick';
